/* eslint-disable comma-dangle */
/* eslint-disable object-curly-newline */
/* eslint-disable operator-linebreak */
/* eslint-disable no-use-before-define */
import React, { useCallback, useEffect } from 'react';
import { Box, CardContent, Grid } from '@mui/material';
import ContainerCard from 'components/Containers/Card/ContainerCard';
import HeaderCard from 'components/Containers/Card/HeaderCard';
import GroupButton from 'components/Buttons/ButtonGroup';
import { FormikProvider, useFormik } from 'formik';
import { useDependencyInjection } from 'hooks/useDependencyInjection';
import PersonalData from '../components/PersonalData';
import AccessData from './components/AccessData';
import * as Yup from 'yup';
import { useParams } from 'react-router-dom';
import { useUserByQueryString } from 'hooks/useUserByQueryString';
import { cleanCpfCnpj } from 'utils';
import UserService from 'services/UserService';

function EditUserPassword() {
  const { classes, disable } = useDependencyInjection();

  const { token } = useParams();

  const { user } = useUserByQueryString();

  const { success, error, history, loadingRequest, requestCompleted } =
    useDependencyInjection();

  const formik = useFormik({
    initialValues: {
      name: '',
      nature: '',
      cpfCnpj: '',
      phone: '',
      email: '',
      professional_qualification: '',
      initial_date: null,
      final_date: null,
      password: '',
      confirm_password: '',
    },
    validationSchema: Yup.object().shape({
      password: Yup.string()
        .matches(
          /^((?=.*[a-z])(?=.*[A-Z])(?=.*[0-9]))/,
          'A senha deve conter ao menos uma letra minúscula, uma letra maiúscula e um número'
        )
        .min(6, 'A senha deve conter ao menos 6 caracteres')
        .required('Campo Obrigatório'),
      confirm_password: Yup.string()
        .oneOf([Yup.ref('password'), null], 'As senhas devem ser iguais!')
        .required('Campo Obrigatório'),
    }),
    onSubmit: (values) => {
      confirmEmail(values.password);
    },
  });

  useEffect(() => {
    function loadUser() {
      if (user) {
        const cpfCnpjCleaned = cleanCpfCnpj(user?.cpf_cnpj);

        if (!user.nature) {
          if (cpfCnpjCleaned?.length === 11) {
            user.nature = 'Pessoa Física';
          } else {
            user.nature = 'Pessoa Jurídica';
          }
        }
        formik.setValues({ ...user });
      }
    }
    loadUser();
  }, []);

  const confirmEmail = useCallback(
    async (password) => {
      try {
        loadingRequest();
        await UserService.confirmUser({ token, password });
        success();
        history.push('/signin');
      } catch (err) {
        error(err.response?.data?.message);
      } finally {
        requestCompleted();
      }
    },
    [error, history, loadingRequest, requestCompleted, success, token]
  );

  return (
    <FormikProvider value={formik}>
      <ContainerCard loading={false}>
        <form onSubmit={formik.handleSubmit}>
          <Box className={classes.root}>
            <HeaderCard />
            <CardContent
              sx={{
                '&.MuiCardContent-root': {
                  padding: 0,
                },
              }}
            >
              <Grid container direction="column" gap={3}>
                <Grid item>
                  <PersonalData disabledFields />
                </Grid>
                <Grid item>
                  <AccessData />
                </Grid>
              </Grid>
            </CardContent>
          </Box>
          <GroupButton
            disable={disable}
            isVisibleCancelButton={false}
            messageDialogError
            disableTemporary={false} // Desativar o botão de delete
            message="Deseja realmente excluir essa venda?"
          />
        </form>
      </ContainerCard>
    </FormikProvider>
  );
}

export default EditUserPassword;
